import {Injectable} from "@angular/core";
import {HttpParams} from "@angular/common/http";

import {ValApiResultat, ValBaseService} from "../../../val-services-communs-lib/src/public-api";
import {ValAppSettingsService} from "../../../val-app-settings-lib/src/public-api";
import {AeFCompleterPiecesJointesFactureAchatParametres, AeFCompleterPiecesJointesFactureAchatResultat} from "./AeFCompleterPiecesJointesFactureAchat";
import {AeFImporterFacturesAchatClientResultat} from "./AeFImporterFacturesAchatClient";
import {AeFRechercherComplementsComptableBt30Parametres, AeFRechercherComplementsComptableBt30Resultat} from "./AeFRechercherComplementsComptableBt30";
import {AeFRapprocherComplementComptableBt30Parametres} from "./AeFRapprocherComplementComptableBt30";
import {AeFInitialiserSaisieRefCommandeFactureAchatParametres, AeFInitialiserSaisieRefCommandeFactureAchatResultat} from "./AeFInitialiserSaisieRefCommandeFactureAchat";
import {AeFMettreAJourRefCommandeFactureAchatParametres} from "./AeFMettreAJourRefCommandeFactureAchat";
import {AeFDonneesSaisieStatutFacturesAchat} from "./AeFRetournerDonneesSaisieStatutFacturesAchat";
import {AeFMettreAJourStatutFacturesAchatParametres} from "./AeFMettreAJourStatutFacturesAchat";
import {AeFSynchroniserCyclesViesFacturesAchatParametres} from "./AeFSynchroniserCyclesViesFacturesAchat";
import {AeFRapprocherCommandesFacturesAchatParametres, AeFRapprocherCommandesFacturesAchatResultat} from "./AeFRapprocherCommandesFacturesAchat";
import {AeFTransmettreFacturesAchatResultat} from "./AeFTransmettreFacturesAchat";
import {AeFTransfererDocumentsFacturesAchatParametres, AeFTransfererDocumentsFacturesAchatResultat} from "./AeFTransfererDocumentsFacturesAchat";
import {AeFCreerPieceAchatFacturesAchatParametres, AeFCreerPieceAchatFacturesAchatResultat} from "./AeFCreerPieceAchatFacturesAchat";
import {AeFRapprocherFactureDossierFacturesAchatParametres, AeFRapprocherFactureDossierFacturesAchatResultat} from "./AeFRapprocherFactureDossierFacturesAchat";
import {AeFMettreAJourActivationFacturesAchatParametres, AeFMettreAJourActivationFacturesAchatResultat} from "./AeFMettreAJourActivationFacturesAchat";
import {AeFMettreAJourRefusFacturesAchatParametres, AeFMettreAJourRefusFacturesAchatResultat} from "./AeFMettreAJourRefusFacturesAchat";
import {AeFMettreAJourCorbeilleGedFacturesAchatParametres, AeFMettreAJourCorbeilleGedFacturesAchatResultat} from "./AeFMettreAJourCorbeilleGedFacturesAchat";
import {AeFEnvoyerStatutsFacturesAchatResultat, AeFMarquerStatutsFacturesAchatResultat, AeFSelectionStatutsAEnvoyerFacturesAchatParametres} from "./AeFStatutsAEnvoyerFacturesAchat";

//Services eFact traitement
@Injectable (
{
  providedIn: 'root'
})
export class EFactTraitementService extends ValBaseService 
{
  //Création
  //  Paramètres
  //    appSettingsService : Service d’accès à la configuration de l’application
  constructor (private appSettingsService: ValAppSettingsService) 
  {
    super ();
  }

  //Url de base
  protected override get BaseUrl () : string 
  {
    return `${this.appSettingsService.Configuration.UrlApi.EFact}/v1.0/traitement/`;
  }

  //Importe les factures d’achat du client
  //  Retourne
  //    Résultat de l’importation des factures d’achat du client
  public async ImporterFacturesAchatClient () : Promise<ValApiResultat<AeFImporterFacturesAchatClientResultat>> 
  {
    let operation: Promise<ValApiResultat<AeFImporterFacturesAchatClientResultat>>;

    operation = this.ExecuterRequetePost<AeFImporterFacturesAchatClientResultat> ("import/vendor-invoice", null);
    
    return operation;
  }

  //Complète les pièces jointes d’une facture d’achat déjà importée
  //  Paramètres
  //    aefCompleterPiecesJointesFactureAchatParametres : Paramètres de complétion des pièces jointes d’une facture d’achat
  //  Retourne
  //    Résultat de la complétion des pièces jointes de la facture d’achat
  public async CompleterPiecesJointesFactureAchat (aefCompleterPiecesJointesFactureAchatParametres: AeFCompleterPiecesJointesFactureAchatParametres) : Promise<ValApiResultat<AeFCompleterPiecesJointesFactureAchatResultat>>
  {
    let operation: Promise<ValApiResultat<AeFCompleterPiecesJointesFactureAchatResultat>>;

    operation = this.ExecuterRequetePost<AeFCompleterPiecesJointesFactureAchatResultat> ("completer/pieces-jointes-facture-achat",
                                                                                        aefCompleterPiecesJointesFactureAchatParametres);

    return operation;
  }

  //Recherche les compléments comptable BT-30
  //  Paramètres
  //    aefRechercherComplementsComptableBt30Parametres : Paramètres de recherche des complément comptable BT-30
  //  Retourne
  //    Résultat de la recherche des compléments comptable BT-30
  public async RechercherComplementsComptableBt30 (aefRechercherComplementsComptableBt30Parametres: AeFRechercherComplementsComptableBt30Parametres) : Promise<ValApiResultat<AeFRechercherComplementsComptableBt30Resultat>> 
  {
    let operation: Promise<ValApiResultat<AeFRechercherComplementsComptableBt30Resultat>>;

    operation = this.ExecuterRequetePost<AeFRechercherComplementsComptableBt30Resultat> ("rechercher/complementcomptable/bt30", aefRechercherComplementsComptableBt30Parametres);

    return operation;
  }

  //Rapproche un complément comptable BT-30
  //  Paramètres
  //    aefRapprocherComplementComptableBt30Parametres : Paramètres de rapprochement d’un complément comptable BT-30
  //  Retourne
  public async RapprocherComplementComptableBt30 (aefRapprocherComplementComptableBt30Parametres: AeFRapprocherComplementComptableBt30Parametres) : Promise<ValApiResultat<any>> 
  {
    let operation: Promise<ValApiResultat<any>>;

    operation = this.ExecuterRequetePost<any> ("rapprocher/complementcomptable/bt30", aefRapprocherComplementComptableBt30Parametres);

    return operation;
  }

  //Transmet les factures d’achat
  //  Déprécié : le geste est scindé en « Transférer les documents » et « Créer la pièce d’achat »
  //  (Fonctionnalité #116844). La route mono-appel est conservée pour les consommateurs d’API
  //  existants, mais l’IHM ne l’expose plus.
  //  Retourne
  //    Résultat de la transmission des factures d’achat
  public async TransmettreFacturesAchat () : Promise<ValApiResultat<AeFTransmettreFacturesAchatResultat>>
  {
    let operation: Promise<ValApiResultat<AeFTransmettreFacturesAchatResultat>>;

    operation = this.ExecuterRequeteGet<AeFTransmettreFacturesAchatResultat> ("transmettre/factures-achat");

    return operation;
  }

  //Transfère les documents des factures d’achat vers le back-office (SU #116854)
  //  Paramètres
  //    aefTransfererDocumentsFacturesAchatParametres : Paramètres portant la sélection de la grille (SU #117296)
  //  Retourne
  //    Résultat du transfert des documents des factures d’achat
  //  Le POST remplace le GET du découpage initial : une liste de GUID en query string plafonnerait
  //  autour de 35 factures. La route est interne et n’a que ce consommateur.
  public async TransfererDocumentsFacturesAchat (aefTransfererDocumentsFacturesAchatParametres: AeFTransfererDocumentsFacturesAchatParametres) : Promise<ValApiResultat<AeFTransfererDocumentsFacturesAchatResultat>>
  {
    let operation: Promise<ValApiResultat<AeFTransfererDocumentsFacturesAchatResultat>>;

    operation = this.ExecuterRequetePost<AeFTransfererDocumentsFacturesAchatResultat> ("transferer/documents/factures-achat",
                                                                                       aefTransfererDocumentsFacturesAchatParametres);

    return operation;
  }

  //Crée les pièces d’achat des factures d’achat côté back-office (SU #116856)
  //  Paramètres
  //    aefCreerPieceAchatFacturesAchatParametres : Paramètres portant la sélection de la grille (SU #117296)
  //  Retourne
  //    Résultat de la création des pièces d’achat des factures d’achat
  public async CreerPieceAchatFacturesAchat (aefCreerPieceAchatFacturesAchatParametres: AeFCreerPieceAchatFacturesAchatParametres) : Promise<ValApiResultat<AeFCreerPieceAchatFacturesAchatResultat>>
  {
    let operation: Promise<ValApiResultat<AeFCreerPieceAchatFacturesAchatResultat>>;

    operation = this.ExecuterRequetePost<AeFCreerPieceAchatFacturesAchatResultat> ("creer/piece-achat/factures-achat",
                                                                                   aefCreerPieceAchatFacturesAchatParametres);

    return operation;
  }

  //Rapproche les factures d’achat d’une facture dossier déjà saisie côté back-office (SU #118215)
  //  Aucune pièce d’achat n’est créée : une facture sans candidate reste à créer par
  //  CreerPieceAchatFacturesAchat, et son détail porte le motif.
  //  Paramètres
  //    aefRapprocherFactureDossierFacturesAchatParametres : Paramètres portant la sélection de la grille
  //  Retourne
  //    Résultat du rapprochement des factures d’achat
  public async RapprocherFactureDossierFacturesAchat (aefRapprocherFactureDossierFacturesAchatParametres: AeFRapprocherFactureDossierFacturesAchatParametres) : Promise<ValApiResultat<AeFRapprocherFactureDossierFacturesAchatResultat>>
  {
    let operation: Promise<ValApiResultat<AeFRapprocherFactureDossierFacturesAchatResultat>>;

    operation = this.ExecuterRequetePost<AeFRapprocherFactureDossierFacturesAchatResultat> ("rapprocher/facture-dossier/factures-achat",
                                                                                            aefRapprocherFactureDossierFacturesAchatParametres);

    return operation;
  }

  //Initialise la saisie de la référence de commande d’une facture d’achat
  //  Parametres
  //    aefInitialiserSaisieRefCommandeFactureAchatParametres : Paramètres d’initialisation de la saisie de la référence de commande d’une facture d’achat
  //  Retourne
  //    Résultat de l’initialisation de la saisie de la référence de commande
  public async InitialiserSaisieRefCommandeFactureAchat (aefInitialiserSaisieRefCommandeFactureAchatParametres: AeFInitialiserSaisieRefCommandeFactureAchatParametres) : Promise<ValApiResultat<AeFInitialiserSaisieRefCommandeFactureAchatResultat>> 
  {
    let operation: Promise<ValApiResultat<AeFInitialiserSaisieRefCommandeFactureAchatResultat>>;
    let parametres: HttpParams;

    parametres = new HttpParams ();

    parametres = parametres.set ("IdentifiantFacture", aefInitialiserSaisieRefCommandeFactureAchatParametres.identifiantFacture);

    operation = this.ExecuterRequeteGet<AeFInitialiserSaisieRefCommandeFactureAchatResultat> ("initialiser/saisie/ref-commande/facture-achat", parametres);

    return operation;
  }

  //Met à jour la référence de commande d’une facture d’achat
  //  Parametres
  //    aefMettreAJourRefCommandeFactureAchatParametres : Paramètres de mise à jour de la référence de commande d’une facture d’achat
  //  Retourne
  //    Résultat de la mise à jour de la référence de commande d’une facture d’achat
  public async MettreAJourRefCommandeFactureAchat (aefMettreAJourRefCommandeFactureAchatParametres: AeFMettreAJourRefCommandeFactureAchatParametres) : Promise<ValApiResultat<any>> 
  {
    let operation: Promise<ValApiResultat<any>>;

    operation = this.ExecuterRequetePost<any> ("mettre/a-jour/ref-commande/facture-achat", aefMettreAJourRefCommandeFactureAchatParametres);

    return operation;
  }

  //Retourne les données de saisie d’un statut pour les factures d’achat
  //  Retourne
  //    Résultat de la récupération des données de saisie d’un statut pour les factures d’achat
  public async RetournerDonneesSaisieStatutFactureAchat () : Promise<ValApiResultat<AeFDonneesSaisieStatutFacturesAchat>> 
  {
    let operation: Promise<ValApiResultat<AeFDonneesSaisieStatutFacturesAchat>>;

    operation = this.ExecuterRequeteGet<AeFDonneesSaisieStatutFacturesAchat> ("donnees/saisie/statut/facture-achat");

    return operation;
  }

  //Met à jour le statut des factures d’achat
  //  Paramètres
  //    aefMettreAJourStatutFacturesAchatParametres : Paramètres de mise à jour du statut des factures d’achat
  //  Retourne
  //    Résultat de la mise à jour du statut des factures d’achat
  public async MettreAJourStatutFacturesAchat (aefMettreAJourStatutFacturesAchatParametres: AeFMettreAJourStatutFacturesAchatParametres) : Promise<ValApiResultat<any>> 
  {
    let operation: Promise<any>;

    operation = this.ExecuterRequetePost<any> ("statut/facture-achat", aefMettreAJourStatutFacturesAchatParametres);

    return operation;
  }

  //Met à jour l’activation des factures d’achat (SU #117315)
  //  Paramètres
  //    aefMettreAJourActivationFacturesAchatParametres : Paramètres portant la sélection de la grille et l’état cible
  //  Retourne
  //    Résultat de la mise à jour de l’activation des factures d’achat
  public async MettreAJourActivationFacturesAchat (aefMettreAJourActivationFacturesAchatParametres: AeFMettreAJourActivationFacturesAchatParametres) : Promise<ValApiResultat<AeFMettreAJourActivationFacturesAchatResultat>>
  {
    let operation: Promise<ValApiResultat<AeFMettreAJourActivationFacturesAchatResultat>>;

    operation = this.ExecuterRequetePost<AeFMettreAJourActivationFacturesAchatResultat> ("activation/factures-achat",
                                                                                         aefMettreAJourActivationFacturesAchatParametres);

    return operation;
  }

  //Met à jour le marquage « à refuser » des factures d’achat (SU #117809)
  //  Paramètres
  //    aefMettreAJourRefusFacturesAchatParametres : Paramètres portant la sélection de la grille et l’état cible
  //  Retourne
  //    Résultat de la mise à jour du marquage « à refuser » des factures d’achat
  public async MettreAJourRefusFacturesAchat (aefMettreAJourRefusFacturesAchatParametres: AeFMettreAJourRefusFacturesAchatParametres) : Promise<ValApiResultat<AeFMettreAJourRefusFacturesAchatResultat>>
  {
    let operation: Promise<ValApiResultat<AeFMettreAJourRefusFacturesAchatResultat>>;

    operation = this.ExecuterRequetePost<AeFMettreAJourRefusFacturesAchatResultat> ("refus/factures-achat",
                                                                                    aefMettreAJourRefusFacturesAchatParametres);

    return operation;
  }

  //Met à jour la corbeille GED de destination des factures d’achat (SU #120249)
  //  Paramètres
  //    aefMettreAJourCorbeilleGedFacturesAchatParametres : Paramètres portant la sélection de la grille et la corbeille cible, nulle pour la retirer
  //  Retourne
  //    Résultat de la mise à jour de la corbeille GED des factures d’achat
  public async MettreAJourCorbeilleGedFacturesAchat (aefMettreAJourCorbeilleGedFacturesAchatParametres: AeFMettreAJourCorbeilleGedFacturesAchatParametres) : Promise<ValApiResultat<AeFMettreAJourCorbeilleGedFacturesAchatResultat>>
  {
    let operation: Promise<ValApiResultat<AeFMettreAJourCorbeilleGedFacturesAchatResultat>>;

    operation = this.ExecuterRequetePost<AeFMettreAJourCorbeilleGedFacturesAchatResultat> ("corbeille-ged/factures-achat",
                                                                                          aefMettreAJourCorbeilleGedFacturesAchatParametres);

    return operation;
  }

  //Synchronise les cycles de vies des factures d’achat
  //  Paramètres
  //    aefSynchroniserCyclesViesFacturesAchatParametres : Paramètres de synchronisation des cycles de vies des factures d’achat
  //  Retourne
  //    Résultat de la synchronisation des cycles de vies des factures d’achat
  public async SynchroniserCyclesViesFacturesAchat (aefSynchroniserCyclesViesFacturesAchatParametres: AeFSynchroniserCyclesViesFacturesAchatParametres) : Promise<ValApiResultat<any>> 
  {
    let operation: Promise<any>;

    operation = this.ExecuterRequetePost<any> ("synchroniser/cycle-vie/facture-achat", aefSynchroniserCyclesViesFacturesAchatParametres);

    return operation;
  }

  //Rapproche les commandes aux factures d’achat
  //  Paramètres
  //    aefRapprocherCommandesFacturesAchatParametres : Paramètres de rapprochement des commandes aux factures d’achat
  //  Retourne <param name="rapprocherCommandesFacturesAchat">              Interface de rapprochement des commandes aux factures d’achat  </param>
  //    Résultat du rapprochement des commandes aux factures d’achat
  public async RapprocherCommandesFacturesAchat (aefRapprocherCommandesFacturesAchatParametres: AeFRapprocherCommandesFacturesAchatParametres) : Promise<ValApiResultat<AeFRapprocherCommandesFacturesAchatResultat>> 
  {
    let operation: Promise<ValApiResultat<AeFRapprocherCommandesFacturesAchatResultat>>;

    operation = this.ExecuterRequetePost<AeFRapprocherCommandesFacturesAchatResultat> ("rapprocher/commandes/factures-achat", aefRapprocherCommandesFacturesAchatParametres);

    return operation;
  }

  //Calcule, depuis l’avancement back-office, les statuts à envoyer des factures d’achat sélectionnées (SU #119400)
  //  Paramètres
  //    aefSelectionStatutsAEnvoyerFacturesAchatParametres : Sélection de la grille
  //  Retourne
  //    Résultat du calcul — rien n’est transmis à la plateforme agréée
  public async MarquerStatutsFacturesAchat (aefSelectionStatutsAEnvoyerFacturesAchatParametres: AeFSelectionStatutsAEnvoyerFacturesAchatParametres) : Promise<ValApiResultat<AeFMarquerStatutsFacturesAchatResultat>>
  {
    let operation: Promise<ValApiResultat<AeFMarquerStatutsFacturesAchatResultat>>;

    operation = this.ExecuterRequetePost<AeFMarquerStatutsFacturesAchatResultat> ("marquer/statuts/factures-achat", aefSelectionStatutsAEnvoyerFacturesAchatParametres);

    return operation;
  }

  //Envoie à la plateforme agréée les statuts à envoyer des factures d’achat sélectionnées (SU #119400)
  //  Paramètres
  //    aefSelectionStatutsAEnvoyerFacturesAchatParametres : Sélection de la grille
  //  Retourne
  //    Résultat de l’envoi — irréversible côté fournisseur
  public async EnvoyerStatutsFacturesAchat (aefSelectionStatutsAEnvoyerFacturesAchatParametres: AeFSelectionStatutsAEnvoyerFacturesAchatParametres) : Promise<ValApiResultat<AeFEnvoyerStatutsFacturesAchatResultat>>
  {
    let operation: Promise<ValApiResultat<AeFEnvoyerStatutsFacturesAchatResultat>>;

    operation = this.ExecuterRequetePost<AeFEnvoyerStatutsFacturesAchatResultat> ("envoyer/statuts/factures-achat", aefSelectionStatutsAEnvoyerFacturesAchatParametres);

    return operation;
  }
}
